// extracted by mini-css-extract-plugin
module.exports = {"TextReader":"TextReader_TextReader__1nLO3","Title":"TextReader_Title__iQgx2","Input":"TextReader_Input__1Ka-u"};